import { useMutation, useQueryClient } from "@tanstack/react-query";
import { showNotification } from "@mantine/notifications";
import { customAxios } from "lib/axios";

interface ResetUserPermissionsResponse {
  success: boolean;
  message: string;
  data: {
    _id: string;
    userId: string;
    role: string;
    permissions: Record<string, unknown>;
    custom: boolean;
  };
}

const resetUserPermissions = async (
  userId: string
): Promise<ResetUserPermissionsResponse> => {
  const res = await customAxios.post<ResetUserPermissionsResponse>(
    `/permissions/users/${userId}/reset`
  );
  return res.data;
};

export const useResetUserPermissions = () => {
  const queryClient = useQueryClient();

  return useMutation<ResetUserPermissionsResponse, unknown, string>({
    mutationFn: resetUserPermissions,
    onSuccess: async (res) => {
      showNotification({
        title: "Permissions reset",
        message: res.message || "Permissions reset to role defaults",
        color: "green",
      });
      await queryClient.invalidateQueries(["all-user-permissions"]);
      await queryClient.invalidateQueries(["userPermissions"]);
    },
    onError: () => {
      showNotification({
        title: "Reset failed",
        message: "Something went wrong",
        color: "red",
      });
    },
    retry: 1,
  });
};
